const DAWN_CART_TAGS = ['cart-drawer', 'cart-items', 'cart-drawer-items', 'cart-notification'];

function collectCartSections() {
  const sections = new Map();
  for (const el of document.querySelectorAll(DAWN_CART_TAGS.join(','))) {
    const entries = el.getSectionsToRender?.() || [];
    for (const entry of entries) {
      const sectionId = entry.section || entry.id;
      if (!sectionId || sections.has(sectionId)) continue;
      const root = entry.section ? document.getElementById(entry.id) : document;
      if (!root) continue;
      const mount = entry.selector
        ? root.querySelector(entry.selector) || (entry.section ? root : null)
        : document.getElementById(entry.id);
      if (mount) sections.set(sectionId, { mount, extractSelector: entry.selector || '.shopify-section' });
    }
  }
  return sections;
}

async function readCartJSON(url) {
  const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
  if (!response.ok) throw new Error('Cart refresh failed');
  return response.json();
}

async function refreshDawnCartUI() {
  const sections = collectCartSections();
  const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) || `${window.Shopify?.routes?.root || '/'}cart`;
  const ids = [...sections.keys()];
  const requests = [];
  for (let index = 0; index < ids.length; index += 5) {
    requests.push(readCartJSON(`${cartUrl}?sections=${encodeURIComponent(ids.slice(index, index + 5).join(','))}`));
  }
  const [cartData, renderedBatches] = await Promise.all([
    readCartJSON(`${cartUrl}.js`),
    Promise.all(requests),
  ]);
  if (!Array.isArray(cartData?.items) || !Number.isInteger(cartData.item_count)) {
    throw new Error('Invalid cart response');
  }
  const rendered = Object.assign({}, ...renderedBatches);
  const replacements = [];
  for (const [id, { mount, extractSelector }] of sections) {
    if (typeof rendered[id] !== 'string') throw new Error(`Cart section unavailable: ${id}`);
    const source = new DOMParser().parseFromString(rendered[id], 'text/html').querySelector(extractSelector);
    if (!source) throw new Error(`Cart section markup unavailable: ${id}`);
    replacements.push({ mount, source });
  }
  for (const { mount, source } of replacements) mount.replaceChildren(...source.childNodes);

  const empty = cartData.item_count === 0;
  document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer').forEach((el) => {
    el.classList.toggle('is-empty', empty);
  });

  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-refresh', cartData });
  }

  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    if (drawer.classList.contains('active') && typeof trapFocus === 'function') {
      const container = empty ? drawer.querySelector('.drawer__inner-empty') : drawer.querySelector('#CartDrawer');
      const focusElement = drawer.querySelector('.drawer__close') || drawer.querySelector('.drawer__inner');
      if (container && focusElement) {
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        trapFocus(container, focusElement);
      }
    }
  }
}

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      return defaultHandler();
    },
  });

  actions.updateCart.configure({
    eventTarget: () => document,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      try {
        await refreshDawnCartUI();
      } catch (error) {
        console.error('[Dawn] Cart refresh failed; reloading.', error);
        window.location.reload();
      }
      return result;
    },
  });
}

if (window.Shopify?.actions) {
  initStandardActions();
} else {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
}
